// The signed-in cashier's own items (UC-17): the ids in their order, and the
// picks they are still making in the edit sheet.
//
// The set is the server's: it belongs to the cashier, not to this till, so it
// is read again whenever a different cashier signs in. The picks are this
// till's: closing the sheet keeps them until Done or until the cashier leaves,
// the way closing any sheet keeps what was typed.

import { api } from '../api/client';

let owner = $state('');
let ids = $state<string[]>([]);
let loaded = $state(false);
let picks = $state<string[] | null>(null);

export function myItems(): string[] {
	return ids;
}

export function myItemsLoaded(): boolean {
	return loaded;
}

/** Read the set of the cashier signed in now. A new cashier starts clean. */
export async function loadMyItems(userId: string): Promise<void> {
	if (userId !== owner) {
		owner = userId;
		ids = [];
		loaded = false;
		picks = null;
	}
	try {
		const { data, error } = await api.GET('/api/till/my-items');
		if (error !== undefined || !data || owner !== userId) return;
		ids = data.itemIds ?? [];
		loaded = true;
	} catch {
		// My items shows its empty line until the next unlock reads it again;
		// every item is still one category away.
	}
}

/** The picks the edit sheet shows: unsaved ones, else the saved set. */
export function currentPicks(): string[] {
	return picks ?? ids;
}

export function setPicks(next: string[]): void {
	picks = next;
}

export type SaveOutcome = 'saved' | 'gone' | 'failed';

/** Save the picks as the whole set. The picks stay unless it went through. */
export async function saveMyItems(): Promise<SaveOutcome> {
	const next = currentPicks();
	try {
		const { data, error } = await api.PUT('/api/till/my-items', { body: { itemIds: next } });
		if (error?.code === 'ITEM_NOT_FOUND') return 'gone';
		if (error !== undefined || !data) return 'failed';
		ids = data.itemIds ?? [];
		picks = null;
		return 'saved';
	} catch {
		return 'failed';
	}
}

/** The cashier left: nothing of theirs stays on this till. */
export function forgetMyItems(): void {
	owner = '';
	ids = [];
	loaded = false;
	picks = null;
}
